<section class="mat-typography">
  <h1>Add Custom Device</h1>
  <hr />
</section>

<div class="container">
  <mat-form-field class="input">
    <mat-label>Custom Device Number</mat-label>
    <input type="text" matInput placeholder="Custom device number" [formControl]="customDeviceNum" required>
    @if (customDeviceNum.errors && customDeviceNum.hasError('required')) {
      <mat-error>Enter a device number.</mat-error>
    }
  </mat-form-field>

  <br />
  <div class="button-container">
    <button mat-raised-button (click)="createCustomDevice()"><span class="material-icons">check</span> Save</button>
    <button mat-raised-button class="padded-btn" (click)="cancel()"><span class="material-icons">close</span> Cancel</button>
  </div>
</div>
